<div class="sow-container">
    <div class="sow-action">
        <button
            class="btn btn-primary btn-online-primary"
            (click)="openModal()"
        >
            {{ "sow.createNewTitle" | translate }}
        </button>
    </div>
    <div class="grid-container">
        <ag-grid-angular
            style="width: 100%; height: 100%"
            [rowData]="SowList"
            [columnDefs]="colDefs"
            [defaultColDef]="defaultColDef"
            (cellEditingStarted)="onCellEditingStarted($event)"
            (cellEditingStopped)="onCellEditingStopped($event)"
            [getRowStyle]="getRowStyle"
            (gridReady)="onGridReady($event)"
            [autoGroupColumnDef]="autoGroupColumnDef"
            [stopEditingWhenCellsLoseFocus]="true"

        />
    </div>
</div>
